import { render } from "./SpmOverlayPanel.vue?vue&type=template&id=767bdbee"
import script from "./SpmOverlayPanel.vue?vue&type=script&lang=ts"
export * from "./SpmOverlayPanel.vue?vue&type=script&lang=ts"

import "./SpmOverlayPanel.vue?vue&type=style&index=0&id=767bdbee&lang=scss"
script.render = render

export default script